enum QueryParam {
  search = "search"
}

const SEPARATOR = "?"

const getSearchParams = () => {
  return new URLSearchParams(location.hash.split(SEPARATOR)[1])
}

export const getSearchValue = (): string | null => {
  const queryParams = getSearchParams()

  return queryParams.get(QueryParam.search)
}

export const setSearchValue = (value: string): void => {
  const queryParams = getSearchParams()

  queryParams.set(QueryParam.search, value)
  location.hash = location.hash.split(SEPARATOR)[0]
    + (value && (SEPARATOR + queryParams.toString()) || "")
}
